<template>
  <nav>
    <v-row align="center">
      <v-col
        v-if="error == ''"
        cols="12"
        sm="8"
        offset-sm="2"
        align="center"
      >
        <AlertMessages
          v-if="alertValue && createSpaceMsg != ''"
          alert-type="success" 
          :alert-msg="createSpaceMsg"
          @reset="alertValue = false"
        />

        <AlertMessages
          v-if="alertValue && deleteSpaceMsg != ''"
          alert-type="success" 
          :alert-msg="deleteSpaceMsg"
          @reset="alertValue = false"
        />

        <p class="text-h5 font-weight-bold text-left text-md-center my-4 my-md-8 mx-4">
          {{ $t('spacePageTitle') }}
        </p>
        <p
          v-if="!mobile()"
          class="text-left text-md-center"
        >
          {{ $t('spacePageText') }}
        </p>
      </v-col>
      <v-col
        v-else
        cols="12"
        sm="8"
        offset-sm="2"
        align="center"
      >
        <AlertMessages
          v-if="alertValue"
          class="mb-8 mx-auto"
          alert-type="error" 
          :alert-msg="error"
          @reset="alertValue = false"
        />
      </v-col>
    </v-row>
    <v-row
      align="center"
      class="mx-auto"
    >
      <v-col
        cols="12"
        sm="8"
        offset-sm="2"
        class="pa-2"
      >
        <v-card
          v-for="space in spaces"
          :key="space.id"
          data-testid="go-to-space-card"
          rounded="xxl"
          class="my-2"
          @click="redirectToSpace(space.attributes.subdomain)"
        >
          <v-hover v-if="!mobile()">
            <v-row
              v-if="!mobile()"
              slot-scope="{ hover }"
              no-gutters
              :class="`py-3 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                sm="2"
                md="2"
                align="center"
              >
                <div class="mx-2">
                  <v-img
                    v-if="space.attributes.icon != null"
                    width="48"
                    height="48"
                    :src="`${space.attributes.icon}`"
                  />
                  <v-img
                    v-else
                    width="48"
                    height="48"
                    :src="iconURL"
                  />
                </div>
              </v-col>

              <v-col
                cols="12"
                sm="12"
                md="4"
                align="left"
              >
                <div class="text-body-2 grey--text">
                  {{ $t('spaceName') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ space.attributes.name }}
                </div>
              </v-col>

              <v-col
                cols="12"
                sm="12"
                md="4"
                align="left"
              >
                <div class="text-body-2 grey--text">
                  {{ $t('spaceUrl') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ space.attributes.subdomain }}.{{ domain }}
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="2"
                align="left"
              >
                <div class="text-body-2 grey--text">
                  {{ $t('subscriptionPlan') }}
                </div>
                <div class="text-body-1 darktext--text">
                   <v-chip v-if="space.attributes.subscription_plan && space.attributes.subscription_plan != 'Business+'" class="rounded-lg align-self-center text-uppercase font-weight-bold px-2" x-small :class="space.attributes.subscription_plan == 'Pro Trial' ? 'darktext--text' : 'white--text'" :color="space.attributes.subscription_plan == 'Free' ? 'pink':
                                                                                             space.attributes.subscription_plan == 'Pro' ? 'accent':
                                                                                             space.attributes.subscription_plan == 'Pro Trial' ? 'anchor20opacity':''
                                                                                             ">{{space.attributes.subscription_plan}}</v-chip>
                  <v-icon v-if="space.attributes.subscription_plan == 'Business+'" color="warning">
                    mdi-crown-circle
                  </v-icon>
                </div>
              </v-col>
            </v-row>
          </v-hover>
          <v-hover v-if="mobile()">
            <v-row
              v-if="mobile()"
              slot-scope="{ hover }"
              no-gutters
              :class="`py-2 elevation-${hover? 8 : 2 }`"
              class="d-flex justify-center align-center"
            >
              <v-avatar
                size="48"
                rounded="0"
                class="ml-6 mr-1"
              >
                <v-img
                  v-if="space.attributes.icon != null"
                  :src="`${space.attributes.icon}`"
                />
                <v-img
                  v-else
                  :src="iconURL"
                />
              </v-avatar>
              <v-col
                sm="9"
                md="8"
                align-self="center"
                class="py-2 px-4 mail-name"
              >
                <v-card-text class="text-body-2 darktext--text pa-0 text-no-wrap text-truncate ">
                  {{ space.attributes.name }}
                </v-card-text>
                <v-card-text class="text-body-3 greytext--text pa-0 text-no-wrap text-truncate ">
                  {{ space.attributes.subdomain }}.{{ domain }}
                </v-card-text>
              </v-col>
            </v-row>
          </v-hover>
        </v-card>   
      </v-col>  
    </v-row>
    <!--Hide the creating new space icon on my spaces page-->
    <!--<PlusButtonWithLink
      data-testid="create-space-button"
      rounded="xxl"
      :link="link"
    />-->
  </nav>
</template>
<script>

import i18n from '../../plugins/i18n';
//import PlusButtonWithLink from '../../components/PlusButtonWithLink'
import { getSpaces } from '../../api/spaceApi';
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages  from '../../components/AlertMessages'

export default {
        components: { 
        //PlusButtonWithLink,
        AlertMessages
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            spaces: [],
            //link: {title: '', route: '/spaces/create'},
            iconURL: require('../../assets/rtpicon.png'),
            deleteSpaceMsg :'',
            createSpaceMsg :'',
            error:'',
            alertValue:false,
            domain: process.env.VUE_APP_DOMAIN,
        }
    },
    async created() {
        //if space was deleted before redirecting to my spaces page
        if(window.$cookies.isKey("show_deleted_space_message")){
            this.deleteSpaceMsg = i18n.t('deleteSpaceMsg')
            this.alertValue = true
            window.$cookies.remove("show_deleted_space_message", null, process.env.VUE_APP_DOMAIN);
        }

        //if space was successfully created
        if(this.$route.params.successfullyCreatedSpace){     
            this.createSpaceMsg = i18n.t('createSpaceSuccess')
            this.alertValue = true
        }

        try {
            const response = await getSpaces()
            if(response.status){
                if(response.status == 200) {
                    this.spaces = response.data.data;
                }
            }
            
        } catch (e) {
            if(e.response){
                //error
            }
            
        }
     },
     methods: {   
        redirectToSpace(url){
            var rel = ""
            window.location.href = process.env.VUE_APP_PROTOCOL + "://" + url + "." + process.env.VUE_APP_DOMAIN + rel
        }
     }
    
}
</script>
